import React, { forwardRef } from "react";

const Comments = forwardRef(({ children, ...props }, ref) => {
  return (
    <ul ref={ref} style={{ width: 300 }}>
      {children}
    </ul>
  );
});

export default Comments;
